import React from "react"
import classnames from "classnames"
import styles from "./ColorIcon.less"
import CheckIcon from './../CheckIcon'
import lightOrDark from 'AtomicUtils/lightOrDark'

const ColorIcon = ({ color = '#910A2D', active=false }) => {
  return (
    <div
      className={classnames({
        [styles.ColorIcon]: true,
        [styles.ColorIconActive]: active,
      })}>
      <div
        className={classnames({
          [styles.ColorIconInside]: true,
        })}
        style={{
          backgroundColor: color
        }}
      >
      {active &&
        <CheckIcon
          style={{
            width: '40%',
            color: lightOrDark(color) === 'dark' ? '#FFFFFF' : '#101010'
          }}
        />
      }
      </div>
    </div>
  )
}

export default ColorIcon




// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/ColorIcon/ColorIcon.jsx